import { cn } from '@/lib/utils';

interface FloatingKpiCardProps {
  title: string;
  subtitle: string;
  className?: string;
}

export function FloatingKpiCard({ title, subtitle, className }: FloatingKpiCardProps) {
  return (
    <div
      className={cn(
        'bg-card/95 backdrop-blur-sm rounded-2xl border border-border/50 shadow-lg',
        'px-4 py-3 max-w-[220px]',
        'transition-transform duration-300 ease-out',
        'hover:scale-[1.02] hover:shadow-xl',
        className
      )}
    >
      <p className="text-sm font-semibold text-foreground leading-tight">{title}</p>
      <p className="text-xs text-muted-foreground mt-1 leading-snug">{subtitle}</p>
    </div>
  );
}
